import FormField from './FormField'

export default class FormFieldData {
  constructor (id, uid, type, value, properties, dataGroup, dataSubGroup, helpText) {
    this.id = id
    this.uid = uid
    this.type = type
    this.value = value
    this.properties = properties
    this.dataGroup = dataGroup
    this.dataSubGroup = dataSubGroup
    this.file = null
    this.files = null
    this.helpText = helpText
    this.isDependencySatisfied = true
  }

  static asFormFieldDatas (json) {
    return json.map(formField => {
      return FormFieldData.asFormFieldData(formField)
    })
  }

  static asFormFieldData (json) {
    return new FormFieldData(
      json.id,
      json.uid,
      json.input_type,
      json.value || FormField.isTextAreaField(json.input_type) ? FormField.parseValue(json.value, json.input_type) : null,
      json.properties ? json.properties : {},
      json.data_group,
      json.data_sub_group,
      json.help_text
    )
  }

  getValue () {
    if (FormField.isCheckboxField(this.type)) {
      if (this.value === null) {
        return false
      }
    }
    return this.value
  }

  get displayValue () {
    if (this.value === null) return null
    let value = this.value
    if (FormField.isRadioField(this.type)) {
      let option = this.properties ? this.properties.options.find((opt) => {
        return opt.option_value === value
      }) : {}
      return option.display_name || value
    }
    if (FormField.isFileField(this.type)) {
      if (this.files) {
        return this.files.map(file => file.name).join(', ')
      }
      if (this.file) {
        return this.file.name
      }
    }
    return value
  }

  resetValue () {
    this.value = null
  }

  toDataObject () {
    return {
      uid: this.uid,
      value: this.value
    }
  }

  copy () {
    return new FormFieldData(this.id, this.uid, this.type, this.value, this.dataGroup, this.dataSubGroup)
  }
}
